import React from "react";
import "./Loader.css";

const Loader = () => {
  return <div className="loader" />;
};

export default Loader;
